import Link from "next/link";

import { routes } from "src/shared/routes";
import { createJsxLink } from "src/utils/create-jsx-link";
import { useRouterExt } from "src/components/reusable/hooks/useRouterExt";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";

export const FAQS: TTeamConfig["LANGUAGES"]["FAQS"] = [
  {
    question: "How do I claim my tickets?",
    answer:
      "There are two different ways to receive tickets for your Oregon Basketball Fan pass depending on whether you purchase the Men's or Women's events! For the Men's Basketball Fan Pass - you will receive a text message at 9AM on game day with information on how to confirm attendance for a game. When you purchase your Women's Basketball Fan pass, you are assigned tickets for every game in the season and do not need to confirm your attendance. ",
  },
  {
    question: "Do I get a ticket to each game on the schedule?",
    answer:
      "Tickets are guaranteed for the games defined in the subscription. There are no penalties for not attending a game, however you do need to confirm your attendance in order to receive a ticket. ",
  },
  {
    question: "How do I access my tickets?",
    answer:
      "You will receive a text message when tickets are made available in your GoDucks App. ",
  },
  {
    question: "How are tickets sent to me?",
    answer: "Tickets are sent 3 hours prior to tip off for every game. ",
  },
  {
    question: "Where will my seats be located?",
    answer: "Seat locations may vary by location for each game. ",
  },
  {
    question: "Can these tickets be transferred to a friend?",
    answer: "Tickets are not eligible for transfer.",
  },
  {
    question: "Can my seats be changed?",
    answer: (
      <>
        Once tickets have been sent to your account, they cannot be changed.
        Please contact{" "}
        <Link href="mailto:tickets@uoregon.edu">tickets@uoregon.edu</Link> for
        any assistance you may require.
      </>
    ),
  },
  {
    question: "Can I link tickets with other pass holders?",
    answer: (
      <>
        Yes, you can create a group to link with other pass holders! Navigate to
        the{" "}
        <Link
          href={{
            pathname: routes.my_group,
            query: { teamSchema: "oregon_basketball" },
          }}
        >
          My Group
        </Link>{" "}
        tab in your menu and copy the invite. This will ensure you are seated
        together for the game. You will need to ensure your group is created and
        all members have joined at least 4 hours prior to game start in order to
        be seated with one another.
      </>
    ),
  },
  {
    question: "Can I bring a friend to a game?",
    answer:
      "At this time, guest tickets are not available for purchase. You will receive a text message and email once those if those become made available for purchase.",
  },
  {
    question: "Can I receive a refund if I cannot attend a game?",
    answer:
      "No, we do not issue any refunds for games you are not able to attend. Passes are non-transferable and non-refundable.",
  },
];

export const TERMS_AND_CONDITION = () => (
  <>
    By purchasing you agree to receive SMS alerts regarding ticket delivery and
    agree to the{" "}
    <Link target="_blank" href="https://www.attend.tech/terms-of-use">
      Terms of Use
    </Link>{" "}
    and{" "}
    <Link target="_blank" href="https://www.attend.tech/privacy-policy">
      Privacy Policy
    </Link>
    .
  </>
);

export const FOOTER_LINKS = () => (
  <>
    <Link
      target="_blank"
      href="https://www.attend.tech/terms-of-use"
      style={{ color: "white " }}
    >
      Terms of Use
    </Link>{" "}
    <Link
      target="_blank"
      href="https://www.attend.tech/privacy-policy"
      style={{ color: "white " }}
    >
      Privacy Policy
    </Link>
  </>
);

export const PASS_PURCHASE_SUCCESS_MESSAGE: TTeamConfig["LANGUAGES"]["PASS_PURCHASE_SUCCESS_MESSAGE"] =
  {
    TITLE: () => <>You&apos;e all set to experience the action!</>,
    DESCRIPTION: () => {
      const router = useRouterExt();
      return (
        <>
          Invite your friends! Create groups{" "}
          <b>
            <u>
              <span
                onClick={() => router.pushSchema(routes.my_group)}
                style={{ cursor: "pointer" }}
              >
                here
              </span>
            </u>
          </b>
          .
        </>
      );
    },
  };

export const REGISTRATION_TERMS_AND_CONDITIONS = () => (
  <>
    By checking this box you agree to receive notifications from the University
    of Oregon and to the{" "}
    {createJsxLink("Terms of Use", "https://www.attend.tech/terms-of-use")} and{" "}
    {createJsxLink("Privacy Policy", "https://www.attend.tech/privacy-policy")}.
  </>
);
